import { LocalStorage } from "../services";

export const _SERVER_URL_ = 'https://srvapi.etebartaban.ir';
const _PROJECT_KEY_ = 'etebarBourse';
const _DEBUG_MODE_ = false;

// define Promise and fetch
if(!window.Promise){ window.Promise = Promise; }

// API request function
const request = async (url, body={}, method='POST', status='') => {
	let full_url = _SERVER_URL_ + url + (['GET'].includes(method) ? ('?' + (new URLSearchParams(body)).toString()) : '');
	let token = LocalStorage.get('token');
	let headers = {
		'Token': token
	}
	if(status !== 'upload') headers['Content-Type'] = 'application/json';
	let options = {
		method,
		headers,
		...(['POST', 'PUT', 'DELETE'].includes(method) ? { body: (status === 'upload' ? body : JSON.stringify(body)) } : {} ),
	}
	return await fetch(full_url, options).then(response => {
		return response.json();
	}).then(response => {
		if(_DEBUG_MODE_){
			console.groupCollapsed(method, url);
			console.log(
				'request:', body, '\n',
				'response:', response, '\n'
			);
			console.groupEnd(method, url);
		}
		return response
	}).catch(error => {
		if(_DEBUG_MODE_){
			console.group(method, url);
			console.error(
				'request:', body, '\n',
				'error:', error, '\n'
			);
			console.groupEnd(method, url);
		}
	});
};
// separate different method requests
export const _get = async (url, params = {}) => await request(url, params, 'GET');
export const _post = async (url, params = {}) => await request(url, params, 'POST');
export const _upload = async (url, params = {}) => await request(url, params, 'POST', 'upload');
const _delete = async (url, params = {}) => await request(url, params, 'DELETE');
const _put = async (url, params = {}) => await request(url, params, 'PUT');

// manage browser local storage
const setLocalStorage = (key, value) => {
	return window.localStorage.setItem(_PROJECT_KEY_ + '-' + key, value);
}
const getLocalStorage = (key) => {
	return window.localStorage.getItem(_PROJECT_KEY_ + '-' + key);
}
const removeLocalStorage = (key) => {
	return window.localStorage.removeItem(_PROJECT_KEY_ + '-' + key);
}

// // manage browser cookie
// const getCookie = (name) => {
// 	let value = "; " + document.cookie;
// 	let parts = value.split("; " + _PROJECT_KEY_ + '-' + name + "=");
// 	if (parts.length == 2) return parts.pop().split(";").shift();
// }
// const setCookie = (name, value, days) => {
// 	let expires = "";
// 	if (days) {
// 		let date = new Date();
// 		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
// 		expires = "; expires=" + date.toUTCString();
// 	}
// 	document.cookie = _PROJECT_KEY_ + '-' + name + "=" + (value || "") + expires + "; path=/";
// }
// const deleteCookie = (name) => {
// 	document.cookie = _PROJECT_KEY_ + '-' + name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
// }

// manage browser session storage
const setSessionStorage = (key, value) => {
	return window.sessionStorage.setItem(_PROJECT_KEY_ + '-' + key, value);
}
const getSessionStorage = (key) => {
	return window.sessionStorage.getItem(_PROJECT_KEY_ + '-' + key);
}
const removeSessionStorage = (key) => {
	return window.sessionStorage.removeItem(_PROJECT_KEY_ + '-' + key);
}

// manage url parameters - get, has, getAll, append, keys, values, entries
export const getUrlParameter = key => new URLSearchParams(window.location.search).get(key);
const hasUrlParameter = key => new URLSearchParams(window.location.search).has(key);
const getAllUrlParameters = key => new URLSearchParams(window.location.search).getAll(key);
const addUrlParameter = key => new URLSearchParams(window.location.search).append(key);
const getUrlParameterKeys = () => new URLSearchParams(window.location.search).keys();
const getUrlParameterValues = () => new URLSearchParams(window.location.search).values();
const getUrlParameterEntries = key => new URLSearchParams(window.location.search).entries(key);
const updateUrlParameter = (key, value) => {
	let queryParams = new URLSearchParams(window.location.search);
	queryParams.set(key, value);
	window.history.replaceState(null, null, "?"+queryParams.toString()); 
};